import { useEffect } from 'react';
import { useMobileHeader } from '../App/context/MobileHeaderContext';

/**
 * Sets mobile header action buttons for the current page.
 * Clears them on unmount.
 * @param {React.ReactNode} actions - JSX to render in the mobile header
 * @param {Array} deps - dependency array for when actions should update
 */
const useMobileHeaderActions = (actions, deps = []) => {
  const { setMobileActions, clearMobileActions } = useMobileHeader();

  useEffect(() => {
    setMobileActions(actions);
    return () => clearMobileActions();
  }, deps); // eslint-disable-line react-hooks/exhaustive-deps
};

export default useMobileHeaderActions;
